import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { Employee } from 'admin/src/types/User';

export type EmployeeState = {
  employees: Employee[];
  loading: boolean;
  error: string | null;
};

const initialState: EmployeeState = {
  employees: [],
  loading: false,
  error: null,
};

const slice = createSlice({
  name: 'employees',
  initialState,
  reducers: {
    loadEmployees: (state) => {
      state.loading = true;
      state.error = null;
    },
    setEmployees: (state, action: PayloadAction<Employee[]>) => {
      state.employees = action.payload;
      state.loading = false;
      state.error = null;
    },
    setEmployeesError: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { loadEmployees, setEmployees, setEmployeesError } = slice.actions;

export default slice.reducer;
